<div class="row row-header">
	<div class="col">
		<h1 data-testid="SUBSYS5_DASHBOARD_TITLE_TXT">
			{{ labels().DASHBOARD_COMPONENT_TITLE }}
		</h1>
	</div>
</div>

<div class="row row-contents justify-content-center">
	<div class="col-xxl-9">
		<tsp-dashboard-device-status />
	</div>
</div>

@if (signin(); as signin) {
<div class="info-signin">
	<label for="signin">{{ labels().DASHBOARD_COMPONENT_LAST_SIGNIN }}</label>
	<span>{{ signin.date | convertDate }}, {{ signin.date | date: "HH:mm:ss" }}</span><br />
	<span>{{ signin.city }}, {{ signin.state }}, {{ signin.country }}</span>
</div>
}